import React from "react";
import Navigation from "../components/Navigation";
import Footer from "../components/Footer";
import About from "../components/APropos";

const APropos = () => {
    return (
        <div>
            <Navigation />
            <About />
            <Footer />
        </div>
    )
}


export default APropos;